import { render, staticRenderFns } from "./MPlatformProcessingFinished.vue?vue&type=template&id=296b9b66&lang=pug&"
import script from "./MPlatformProcessingFinished.vue?vue&type=script&lang=js&"
export * from "./MPlatformProcessingFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports